<template>
    <div class="node" :class="{ expanded , selected:this.$store.state.actions.selectedItem && node.id === this.$store.state.actions.selectedItem.id }">
        <div class="group text" v-if="hasChildren" v-on:click="onSelect" v-on:dblclick="onEdit">
            <v-icon>{{expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
            {{ node.name }}
        </div>
        <div class="text noChildren" v-else @click="onSelect" v-on:dblclick="onEdit">{{ node.name }}</div>
        <tree-node :mode="mode" v-if="hasChildren" v-show="expanded" :node="node" v-for="(node, index) in node.children" :key="index" />
    </div>
</template>


<script>
import bus from '../bus';

export default {
  props: ['node', 'mode'],
  name: 'TreeNode',
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    hasChildren() {
      return this.node.children && this.node.children.length;
    }
  },
  methods: {
    onSelect() {
      if (this.hasChildren) {
        this.expanded = !this.expanded;
        if (this.mode === 'select') {
          return;
        }
      }

      if (
        this.$store.state.actions.selectedItem &&
        this.node.id === this.$store.state.actions.selectedItem.id
      ) {
        this.$store.commit('actions/SELECT', null);
      } else {
        this.$store.commit('actions/SELECT', this.node);
      }
    },

    onEdit() {
      if (this.mode === 'select') return;
      this.$store.commit('actions/SELECT', this.node);
      bus.$emit('action', this.node);
    }
  }
};
</script>

<style scoped>
.node {
  padding-left: 20px;
}
.expanded {
}

.text {
  height: 50px;
  line-height: 50px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  .selected > & {
    background-color: rgba(0, 0, 255, 0.1);
  }

  &.noChildren {
    padding-left: 7px;
  }
}
</style>

